var audio_default = {
  "fontElementMap": "TOtrk",
  "container": "_5O6JI",
  "coverImageContainer": "g-KZB",
  "customPlayer": "voD-7",
  "slim": "IHgOE",
  "playPauseButton": "dUf0R",
  "coverImage": "jnEFl",
  "trackDetailsContainer": "g3pjH",
  "controlsContainer": "FOKYZ",
  "controlsGroup": "tSicq",
  "sliderContainer": "_5XFmh",
  "audioDuration": "GV6rg",
  "isLoading": "BUUrM",
  "audioDetails": "mZ51r",
  "authorName": "IqvbL",
  "title": "_8uVF-",
  "dropdownMenuWrapper": "rnHcA",
  "dropdownSelectedButton": "dbte-",
  "dropdownContent": "_0PUzx",
  "dropdownContentWithIcon": "_4OBpf",
  "audioLoader": "MZvMz"
};
export {
  audio_default as default
};
//# sourceMappingURL=audio-scss.js.map
